<div mat-dialog-title class="change-site-state">
  Edit Site{{ data.sites.length > 1 ? 's' : '' }}
  <div class="close-icon-container" (click)="onNoClick()">
    <fa-icon [icon]="['far', 'xmark']" class="gray"></fa-icon>
  </div>
</div>
<mat-divider></mat-divider>
<div mat-dialog-content>

  <form [formGroup]="changeSiteStateForm" class="site-form">
    <span class="change-to-label">New Status:</span>
    <mat-form-field class="status-select">
      <mat-select formControlName="transitionToState" placeholder="New Site State">
        <mat-option value="">No Change</mat-option>
        @for (category of data.categories; track category) {
          <mat-optgroup [label]="category">
            @for (status of siteStatusService.getStatusByCategory(category); track status) {
              <mat-option [value]="status.name">
                {{ status.name }}
              </mat-option>
            }
          </mat-optgroup>
        }
      </mat-select>
    </mat-form-field>
    <span class="change-to-label">Clear Original Submit Date?</span>
    <mat-slide-toggle
      class="switch-type"
      color="primary"
      formControlName="clearSubmitDate">
    </mat-slide-toggle>
  </form>
  @if (canSubmit()) {
    <p class="line-1">
      CONFIRMATION: You are about to edit {{ data.sites.length }} site{{ data.sites.length > 1 ? 's' : '' }}:
    </p>
    <ul>
      @if (changeSiteStateForm.controls.transitionToState.value) {
        <li>
          Change status to
          <strong>
            {{ changeSiteStateForm.get('transitionToState').value }}
          </strong>
        </li>
      }
      @if (changeSiteStateForm.controls.clearSubmitDate.value) {
        <li>
          Clear Original Submitted Date. This will require the Landowner to resubmit their site with a fresh data and
          offer terms.
        </li>
      }
    </ul>
    <p class="line-1">
      Note: Only those sites with a valid change will be updated.
    </p>
  }
  @if (errorMessage) {
    <div class="message-error">ERROR: {{ errorMessage }}</div>
  }
</div>
<div mat-dialog-actions>
  <button mat-stroked-button color="primary" [mat-dialog-close]="false">
    {{ data.buttonTextNo }}
  </button>
  <button
    data-cy="button-yes"
    mat-raised-button
    color="primary"
    class="green-shadow-button"
    [disabled]="!canSubmit()"
    (click)="doChangeSitesState()">
    {{ data.buttonTextYes }}
  </button>
</div>
